<ng-progress></ng-progress>
<upsc-flex-header></upsc-flex-header>
<router-outlet></router-outlet>
<upsc-flex-footer></upsc-flex-footer>
